<template>
  <div class="step">
    <div class="step-wrapper">
      <h2>Дополнительные уточняющие вопросы <br>по анамнезу заболевания</h2>
      <p class="description">Выберите несколько верных ответов</p>
      <div class="items">
        <div v-for="(item, index) in items" class="item" :key="item.title" :class="itemClass(item)">
          <div class="item-title" @click="checkItem(item)">
            <img :src="checkboxState(item)" />
            {{ item.title }}<template v-if="item.opened">:</template>
          </div>
          <hand v-if="index === 0 && showItemHand" class="hand" :right="true" />
          <div class="item-description" v-if="answered" v-html="item.description" />
        </div>
      </div>
      <div v-if="!answered" class="step-button" @click="answered = true"><span>Ответить<hand v-if="!showItemHand" /></span></div>
    </div>
    <div class="step-next" @click="$emit('step', 'syndromes')">
      <span>Синдромы</span>
      <svg viewBox="0 0 27 12" width="27" height="12">
        <path fill="#FFF" fill-rule="evenodd" d="M.01 5h17.14C15.83 3.07 15.17 1.8 15.1.09c3.01 2.96 6.93 4.5 11.67 5.95C22.03 7.43 18.29 9.12 15.1 12c.2-1.86.75-2.99 2.1-5.04H0V5z"/>
      </svg>
    </div>
    <div class="step-help">
      <div class="video-opener" @click="$emit('video', 'help-1')">
        <span>
          <img src="@/assets/help.png">
          Видео-подсказка
        </span>
      </div>
      <hand />
    </div>
  </div>
</template>

<script>
import Hand from './hand'

export default {
  components: {
    Hand
  },
  data () {
    return {
      answered: false,
      items: [
        {
          name: 'q-1',
          title: 'Усиливается ли головокружение при поворотах головы, укладывании и вставании с кровати?',
          description: 'Значительно усиливается при поворотах головы, незначительно — при укладывании, вставании с кровати и поворотах с боку на бок.',
          checked: false,
          correct: true
        },
        {
          name: 'q-2',
          title: 'Отмечается ли боль в ухе, снижение слуха или шум в ушах?',
          description: 'Нет.',
          checked: false,
          correct: true
        },
        {
          name: 'q-3',
          title: 'Отмечается ли головная боль?',
          description: 'Отмечает умеренно-выраженную головную боль, обычно вечером, возникает при выраженном переутомлении. До возникновения головные боли редко, 1 раз в 2–3 месяца, диффузного характера, связывает с переутомлением или стрессом, хорошо купировались ибупрофеном.',
          checked: false,
          correct: true
        },
        {
          name: 'q-4',
          title: 'В какую сторону у вас кружится голова: по часовой стрелке или против?',
          checked: false,
          correct: false
        }
      ]
    }
  },
  computed: {
    showItemHand () {
      return !this.items.some(
        el => el.checked === true
      )
    }
  },
  methods: {
    checkItem (item) {
      if (!this.answered) {
        item.checked = !item.checked
      }
    },
    itemClass (item) {
      return {
        'item--error': !item.correct && this.answered,
        'item--correct': item.correct && this.answered
      }
    },
    checkboxState (item) {
      const state = item.checked ? (!this.answered || item.correct ? 'checkbox-on' : 'checkbox-error') : 'checkbox-off'
      return require('@/assets/' + state + '.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.description {
  font-size: 16px;
  color: #252628;
  margin: 0;
  padding: 0;
  font-style: italic;
}
.step-button {
  position: relative;
}
.items {
  padding: 0 160px 0 0;
  margin: 0 0 32px;

  @include media-down(lg) {
    margin: 0 0 24px;
  }

  @include media-down(md) {
    padding: 0;
  }
}
.item {
  margin: 20px 0 20px 20px;
  line-height: 1.1;
  position: relative;

  .hand {
    top: 20px;
    left: -50px;
  }

  @include media-down(lg) {
    margin: 15px 0 15px 20px;
  }

  &--correct {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  &--error {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  &-title {
    color: #252628;
    font-weight: bold;
    font-size: 18px;
    cursor: pointer;
    position: relative;

    @include media-down(lg) {
      font-size: 16px;
    }

    img {
      position: absolute;
      left: -20px;
      top: .15em;
    }
  }

  &--correct &-title {
    color: #009cde;
  }
  &--error &-title {
    color: #cd0000;
  }

  &-description {
    font-size: 16px;
    color: #252628;
    margin: 5px 0 0;

    @include media-down(lg) {
      font-size: 14px;
    }
  }
}
</style>
